import { store } from 'Models/Store';
import gql from 'graphql-tag';
import { CourseEntity } from 'Models/Entities';

export const GET_ALL_COURSES = gql`
	query getCourses {
		courseEntitys {
			id
			name
			code
			shortName
			units
			level
			terms {
				id
				term {
					id
					name
					studyPeriod {
						id
						name
					}
				}
			}
			campuss {
				id
				campus {
					id
					name
				}
			}
			requisiteLogicGroups {
				id
				isTopLevelGroup
				description
			}
			courseLevel {
				id
				level
			}
			discipline {
				id
				name
				schoolId
				school {
					id
					name
					facultyId
					faculty {
						id
						name
					}
				}
			}
			graduateLevels {
				id
				graduateLevel {
					id
					name
				}
			}
		}
	}
`;

export const GET_COURSE_DETAILS_QUERY = gql`
		query getCourse($id: ID) {
			courseEntity(id: $id) {
				id
				courseId
				code
				name
				shortName
				description
				level
				units
				requisiteLogicGroups {
					id
					isTopLevelGroup
					description
				}
				graduateLevels {
					id
					graduateLevel {
						id
						name
					}
				}
				courseLevelId
				courseLevel {
					id
					level
				}
				campuss {
					id
					campus {
						id
						name
					}
				}
				terms {
					id
					term {
						id
						name
						studyPeriod {
							id
							name
						}
					}
				}
				discipline {
					id
					name
					school {
						id
						name
						faculty {
							id
							name
						}
					}
				}
			}
		}
	`;

export const GET_COURSE_ROOT_LOGIC_GROUP = gql`
	query getRootLogicGroup($id: String) {
		logicGroupEntity(
		where: [
			{path: "assignedCourse.id", comparison: equal, value: [$id]},
			{path: "isTopLevelGroup", comparison: equal, value: ["true"]}
			]
		) {
			id
			description
			isTopLevelGroup
			assignedCourse {
				id
			}
			childLogicGroups {
				id
			}
			requisiteCourses {
				id
			}
		}
	}
`;

export const GET_INSTITUTION_DATA_QUERY = gql`
			query getInstitutionData {
				institutionEntity {
					id
					name
					studyPeriodss {
						id
						name
						terms {
							id
							name
						}
					}
					courseLevels {
						id
						level
					}
					campuss {
						id
						name
					}
					graduateLevelss {
						id
						name
					}
					facultys {
						id
						name
						schools {
							id
							name
							disciplines {
								id
								name
							}
						}
					}
				}
			}
		`;

export const GET_COURSE_REQUISITES_QUERY = gql`
	query getCourseRequisites($id: ID) {
		courseEntity(id: $id) {
			id
			name
			requisiteLogicGroups {
				id
				description
				isTopLevelGroup
				parentLogicGroupId
				assignedCourseId
				condition
				created
				childLogicGroups {
					id
					created
				}
				requisiteCourses {
					id
					logicGroupId
					requisiteType
					created
					requisiteCourse {
						id
						name
						code
					}
				}
			}
		}
	}
`;

export const SEARCH_COURSES_BY_CODE = gql`
	query getCourseRequisites($searchTerm: String) {
		courseEntitys(
			conditions: [[
				{ path: "code", comparison: like, value: [$searchTerm], case: INVARIANT_CULTURE_IGNORE_CASE},
				{ path: "name", comparison: like, value: [$searchTerm], case: INVARIANT_CULTURE_IGNORE_CASE}
			]],
			take: 50,
			orderBy: [{ path: "code" }]
		) {
			id
			code
			name
		}
	}
`;

export const getAllCourses = async (abortSignal: AbortSignal) => {
	return store.apolloClient.query<{
		courseEntitys: CourseEntity[]
	}>({
		query: GET_ALL_COURSES,
		fetchPolicy: 'network-only',
		context: {
			fetchOptions: {
				signal: abortSignal,
			},
		},
	});
};

export const getCourse = async (id: string, abortSignal: AbortSignal) => {
	return store.apolloClient.query<{
		courseEntity: CourseEntity
	}>({
		query: GET_COURSE_DETAILS_QUERY,
		fetchPolicy: 'network-only',
		variables: {
			id,
		},
		context: {
			fetchOptions: {
				signal: abortSignal,
			},
		},
	});
};
